<template>
  <div class="hidden relative lg:flex mb-16 items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full">
    <div class="px-12 cursor-default w-full">
      <p class="text-4xl text-gray-900">
        {{ moduleName }}
      </p>
      <div class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72">
        <slot name="description" />
      </div>
      <slot name="ariane-wire" />
    </div>
    <illustration
      :name="illustrationName"
      class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
    />
  </div>
</template>

<script>
import Illustration from './Illustration.vue';

export default {
  components:{
    Illustration
  },

  props:{
    moduleName:{
      type:String,
      required: true,
    },
    illustrationName:{
      type:String,
      required:true
    }
  }
};
</script>